import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";
import {
  RekapSerahTerimaKantongFilter,
  RekapSerahTerimaKantongResponse
} from "@/types/serah_terima_kantong_darah";

function params(f: RekapSerahTerimaKantongFilter) {
  return {
    tgl_start: f.tgl_start || undefined,
    tgl_end: f.tgl_end || undefined,
    term: f.term || undefined
  };
}

async function list(f: RekapSerahTerimaKantongFilter): Promise<RekapSerahTerimaKantongResponse> {
  const res = await http
    .getDataParam("/laporan/bank-darah/rekap-serah-terima-kantong", { params: params(f) })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return res.data.data;
}

async function downloadExcel(f: RekapSerahTerimaKantongFilter): Promise<void> {
  const res = await http
    .getDataParam("/laporan/bank-darah/rekap-serah-terima-kantong/excel", {
      params: params(f),
      responseType: "blob"
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  const url = URL.createObjectURL(
    new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
  );
  const a = document.createElement("a");
  a.href = url;
  a.download = `rekap-serah-terima-kantong-darah_${f.tgl_start}_${f.tgl_end}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default { list, downloadExcel };
